export const VALID_FILE_TYPES = [
  'application/x-zip-compressed',
  'application/zip',
  'application/mp4',
  'application/msword',
  'application/pdf',
  'application/postscript',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/x-ms-wma',
  'audio/x-wav',
  'image/gif',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/vnd.adobe.photoshop',
  'image/x-icon',
  'text/csv',
  'video/3gpp',
  'video/3gpp2',
  'video/mp4',
  'video/ogg',
  'video/quicktime',
  'video/x-ms-wmv',
  'video/x-msvideo'
];

export const MAX_FILE_SIZE_IN_BYTES = 5368709120;

export default function isValid(file, onTypeFailure = null, onSizeFailure = null) {
  const validType = VALID_FILE_TYPES.includes(file.type);
  const validSize = file.size < MAX_FILE_SIZE_IN_BYTES;

  if (!validType) {
    if (onTypeFailure) onTypeFailure('The file type is not supported.', file.type);
    return false;
  }

  if (!validSize) {
    if (onSizeFailure) onSizeFailure('The file was too large to upload.', file.size);
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./app/javascript/app/utils/fileUploadValidator.js